import React from 'react';
import { ShareIcon } from 'assets/svg/Share';

export default function ShareButton() {
  // Only show share button on mobile (Cordova) app
  if (!window.cordova) {
    return null;
  }

  const handleShare = () => {
    // Check if we're running in Cordova environment
    if (window.cordova && window.plugins?.socialsharing) {
      const shareUrl = 'https://www.smoove.world/app';
      const shareSubject = 'Smoove Exchange App';
      const shareMessage = 'Check out Smoove Exchange!';

      window.plugins.socialsharing.shareWithOptions(
        {
          message: shareMessage,
          subject: shareSubject,
          url: shareUrl,
          chooserTitle: shareSubject,
        },
        () => {
          //   console.log('Share successful');
        },
        (error: unknown) => {
          console.error('Share failed:', error);
        },
      );
    }
  };

  return (
    <button className="header-button relative" onClick={handleShare} title="Share App">
      <div className="h-[32px] w-[32px] md:h-[28px] md:w-[28px] rounded-full bg-brand-gray-soft flex items-center justify-center">
        <ShareIcon className="text-brand-black h-[20px] w-[20px] touch-none" />
      </div>
    </button>
  );
}
